import * as React from 'react';

import Grid from '@mui/material/Grid';

import Image1 from '../../../images/service/Privatgarten_oben.jpg';
import Image2 from '../../../images/service/Privatgarten_mitte.jpg';
import Image3 from '../../../images/service/Privatgarten_unten.jpg';

export default function PicturesPriv() {

  return (
    <div>

      <Grid container spacing={0}>

        <Grid item xs={12} md={12} lg={4} className='photogallery' >

          <img src={Image1} className='gallery' alt="gallery"/>

        </Grid>
        <Grid item xs={12} md={12} lg={4} className='photogallery' >


          <img src={Image2} className='gallery'  alt="gallery"/>


        </Grid>

        <Grid item xs={12} md={12} lg={4} className='photogallery'>


          <img src={Image3} className='gallery'  alt="gallery"/>


        </Grid>

      </Grid>

    </div>

  );
}
